export const APPINSIGHTSCLOUDROLE = 'Authorization.UI';

// Trace
export const SUCCESSFULSIGNINTRACEMSG = 'Successful sign-in.';

// Events
